enum HttpCodes {
  Success = 200,
  NoContent = 204,

  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  UnprocessableEntity = 422,

  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Error4xx = 400,
  Error5xx = 500,
}

enum ErrorCodes {
  Captcha = "CaptchaError",
  CardMergeBlocked = "cardMergeBlocked",
  IncompleteProfile = "incompleteProfile",
  IncompleteProfileInfo = "incomplete_profile_info",
  UnprocessableEntity = "unprocessableEntity",
  AlreadyAccepted = "alreadyAccepted",
  EmailForbidden = "emailForbiddenToUse",
  ValidationError = "validationError",
  UserNotFound = "user_not_found",
  ProfileNotFound = "profileNotFound",
}

/**
 * @swagger web-gateway: https://web-gateway.dev.ya.magnit.ru/docs/index.html
 * @swagger omni-web: https://omni-web.k8s.dev.mos.corp/docs
 * @swagger magnit-id: https://id.dev.ya.magnit.ru/docs/index.html
 */
const urls = {
  otp: {
    /**
     * Генерация и отправка OTP кода по номеру телефона
     * @link: https://id.dev.ya.magnit.ru/docs/index.html#/authorization/MagnitIDSendOTPV1
     */
    getCode: "/v1/auth/otp",
    /**
     * Проверка OTP и получение MagnitID Code кода для авторизации нового пользователя
     * @link: https://id.dev.ya.magnit.ru/docs/index.html#/authorization/MagnitIDCheckOTPV1
     */
    checkCode: "/v1/auth/otp/check",
  },
  auth: {
    /**
     * Авторизация
     * @link: https://id.dev.ya.magnit.ru/docs/index.html#/authorization/MagnitIDGenerateTokenV1
     */
    login: "/v1/auth/token",
    /**
     * Обновление JWT токена
     * @link: https://id.dev.ya.magnit.ru/docs/index.html#/authorization/MagnitIDRefreshTokenV1
     */
    refresh: "/v1/auth/token/refresh",
    exchangeExternalToken: "/v1/auth/cross-token/exchange",
  },
  user: {
    /**
     * Получаем информацию для отрисовки QR-кода
     * @link: https://omni-web.k8s.dev.mos.corp/docs#/cards-v2/cardsV2GetV1UserTotp
     */
    qrcode: "/v1/user/totp",
    /**
     * Получаем информацию по бонусам
     * @link: https://omni-web.k8s.dev.mos.corp/docs#/balances-v2/balancesV2GetV3UserBalance
     */
    balance: "/v3/user/balance",
    /**
     * Получаем информацию по выгодам и бенефитам
     * @link: https://omni-web.k8s.dev.mos.corp/docs#/balances-v2/balancesV2GetV2UserBenefits
     */
    benefits: "/v2/user/benefits",
    /**
     * Получаем информацию по сгорающим стикерам
     * @link: https://omni-web.k8s.dev.mos.corp/docs#/balance/balanceGetV1UserNextStickerExpiration
     */
    nextStickerExpiration: "/v1/user/next-sticker-expiration",
    /**
     * Получаем карточки пользователя
     * @link: https://web-gateway.dev.ya.magnit.ru/docs/index.html#/cards-v2/get_v2_user_cards
     */
    cards: "/v2/user/cards",
    /**
     * Смерживаем вертуальную и физическую карты
     * @link: https://omni-web.k8s.dev.mos.corp/docs#/cards-v2/cardsV2PostV2UserCardMerge
     */
    cardMerge: "/v2/user/card/merge",
    /**
     * Подтверждение e-mail
     * @link: https://id.dev.ya.magnit.ru/docs/index.html#/profiles/MagnitIDEmailConfirmV1
     */
    emailConfirmation: "/v1/profile/email-confirm",
    /**
     * Регистрация нового пользователя
     * @link: https://id.dev.ya.magnit.ru/docs/index.html#/profiles/MagnitIDRegisterProfileByMagnitIDCodeV1
     */
    register: "/v3/profile/register/magnit-id-code",
    /**
     * Получаем профиль пользователя и осуществляем доп. проверку его персональных данных (GET)
     * https://omni-web.k8s.dev.mos.corp/docs#/magnitid/magnitidGetV1KeeperidBunch
     */
    checkUserProfile: "/v1/keeperid/bunch",
    /**
     * Получаем профиль пользователя или обновляем (patch)
     * https://id.dev.ya.magnit.ru/docs/index.html#/profiles/MagnitIDGetProfileV3
     */
    profile: "/v1/profile",
    /**
     * Получение/изменение разрешений пользователя на коммуникации
     * https://omni-web.k8s.dev.mos.corp/docs#/cuscom-v2/cuscomV2GetCuscomV2UserPermissions
     */
    permissions: "/cuscom/v2/user/permissions",
    /**
     * Сохраняем push-токен и передаем состояние системного разрешения на показ уведомлений на сервер Cuscom
     * https://omni-web.k8s.dev.mos.corp/docs#/cuscom-v2/cuscomV2PostCuscomV3UserDeviceEnroll
     */
    enrollDevice: "/cuscom/v3/user-device/enroll",
    /**
     * Получение/назначение любимых категорий пользователя.
     * https://omni-web.k8s.dev.mos.corp/docs#/favorite-categories/favoriteCategoriesGetV1FavoriteCategories
     */
    favoriteCategories: "/v1/favorite-categories",
    /**
     * назначение любимых категорий пользователя.
     * https://omni-web.k8s.dev.mos.corp/docs#/favorite-categories/favoriteCategoriesPostV1FcOptIn
     */
    favoriteCategoriesOptIn: "/v1/fc-opt-in",
    /**
     * Деактивация профиля магнит
     * https://id.dev.ya.magnit.ru/docs/index.html#/profiles/MagnitIDDeactivateProfileV1
     */
    deactivate: "/v1/profile/deactivate",
  },
  wallets: {
    /**
     * Добавление карты в кошелёк
     * @link: https://web-gateway.dev.ya.magnit.ru/docs/index.html#/wallets/post_v1_wallets_apple_release_card
     * @link: https://web-gateway.dev.ya.magnit.ru/docs/index.html#/wallets/post_v1_wallets_google_release_card
     */
    android: "/v1/wallets/google/release-card",
    apple: "/v1/wallets/apple/release-card",
  },
  coupons: {
    /**
     * Получение всех купонов
     * https://omni-web.k8s.dev.mos.corp/docs#/coupons-api/couponsApiGetV1UserCoupons
     */
    list: "/v2/user/coupons",
    /**
     * Получение категорий купонов
     * https://omni-web.k8s.dev.mos.corp/docs#/coupons-api/couponsApiGetV2CouponsCategories
     */
    categories: "/v2/coupons/categories",
    /**
     * Отметить купон как любимый/нелюбимый
     * https://omni-web.k8s.dev.mos.corp/docs#/coupons-api/couponsApiPostV2UserCouponsFavorite
     */
    favorite: "/v2/user/coupons/favorite",
    /**
     * Выполнение запроса для активации купона.
     * https://omni-web.k8s.dev.mos.corp/docs#/offers/offersPostV2OffersOptIn
     */
    activate: "/v2/offers/opt-in",
  },
  content: {
    /**
     * Данные для страницы cookie.
     * https://omni-web.k8s.dev.mos.corp/docs#/configurator-api/configuratorApiGetV1WebCommonContentCookies
     */
    cookie: "/v1/web-common-content/cookies",
  },
  myMagnit: {
    /**
     * Метод получения adfox слайдов на странице today
     * https://omni-web.k8s.dev.mos.corp/docs#/configurator-api/configuratorApiGetV1MyMagnitRuTodayAdfox
     */
    todayAdfox: "/v1/my-magnit-ru/today/adfox",
  },

  ab: {
    /**
     * Расширенный метод получения экспериментов
     * https://omni-web.k8s.dev.mos.corp/docs#/ab/abPostAbV1ExperimentsAndFeatures
     */
    experiments: "/ab/v1/experiments-and-features",
  },
  personalPromotions: {
    /**
     * Получение персональных предложений
     * https://omni-web.k8s.dev.mos.corp/docs#/promoter/promoterGetV2UserPersonalPromotions
     */
    list: "/v2/user/personal-promotions",

    /**
     * Получение деталей по персональному предложению
     * https://omni-web.k8s.dev.mos.corp/docs#/promoter/promoterGetV1UserPersonalPromotionsByPromotionCode
     */
    detail: "/v1/user/personal-promotions/",

    /**
     * Активация персонального предложения
     * https://omni-web.k8s.dev.mos.corp/docs#/offers/offersPostV3OffersOptIn
     */
    activate: "/v3/offers/opt-in",
  },
  transactions: {
    /**
     * Получение списка транзакций
     * https://omni-web.k8s.dev.mos.corp/docs#/balance/balanceGetV3UserTransactions
     */
    list: "/v3/user/transactions",
    /**
     * Получение транзакции по ID
     * https://omni-web.k8s.dev.mos.corp/docs#/balance/balanceGetV2UserTransactionsByTransactionId
     */
    item: "/v2/user/transactions",
    /**
     * Получение html чека операции по receiptId
     * https://omni-web.k8s.dev.mos.corp/docs#/receipts/receiptsGetV1Receipt
     */
    receipt: "/v1/receipt",
  },

  paymentMethods: {
    /**
     * Возвращает список доступных для пользователя платежных методов
     * https://omni-web.k8s.dev.mos.corp/docs#/payment-methods/paymentMethodsGetV2PaymentMethods
     */
    cards: "/v2/payment-methods",

    /**
     * Выбирает платежный метод по умолчанию.
     * https://omni-web.k8s.dev.mos.corp/docs#/payment-methods/paymentMethodsPutV2PaymentMethodsDefault
     */
    cardDefault: "/v2/payment-methods/default",

    /**
     * Метод получения ссылки для привязки новой банковской карты
     * https://omni-web.k8s.dev.mos.corp/docs#/payment-methods/paymentMethodsPostV2PaymentMethodsCardsBind
     */
    bind: "/v2/payment-methods/cards/bind",
    /**
     * Метод получения ссылки для привязки новой банковской карты через SberPay
     * https://omni-web.k8s.dev.mos.corp/docs#/payment-methods/paymentMethodsPostV2PaymentMethodsSberpayBind
     */
    sberPayBind: "/v2/payment-methods/sberpay/bind",
    /**
     * Колбэк для успешной привязки карты по SberPay.
     * https://omni-web.k8s.dev.mos.corp/docs#/payment-methods/paymentMethodsGetV2PaymentMethodsSberpayBindSuccess
     */
    sberPayBindSuccess: "/v2/payment-methods/sberpay/bind/success",
  },

  subscription: {
    /**
     * Метод получения данных по лендингу подписок
     * https://omni-web.k8s.dev.mos.corp/docs#/subscriptions-v2/subscriptionsV2GetWebV2SubscriptionLanding
     */
    landing: "/v2/subscription/landing",

    /**
     * Метод оформления подписки
     * https://omni-web.k8s.dev.mos.corp/docs#/subscriptions-v2/subscriptionsV2PostWebV2SubscriptionSubscribe
     */
    subscribe: "/v2/subscription/subscribe",

    /**
     * Метод отписки
     * https://omni-web.k8s.dev.mos.corp/docs#/subscriptions-v2/subscriptionsV2GetV2SubscriptionUnsubscribe
     */
    unsubscribe: "/v2/subscription/unsubscribe",

    /**
     * Возвращает статус подписки
     * https://omni-web.k8s.dev.mos.corp/docs#/subscriptions-v2/subscriptionsV2GetWebV2SubscriptionStatus
     */
    status: "/v2/subscription/status",

    /**
     * Возобновляет подписку
     * https://omni-web.k8s.dev.mos.corp/docs#/subscriptions-v2/subscriptionsV2GetV2SubscriptionRestore
     */
    restore: "/v2/subscription/restore",
  },

  /* todo: префикс /api - будет удален в ближайшее время */
  goods: {
    /**
     * Добавление товаров в списки пользователя
     * https://omni-web.k8s.dev.mos.corp/docs#/goods-lists/goodsListsPostApiV1GoodsAdd
     */
    add: "/api/v1/goods/add",

    /**
     * Удаление товаров из списков пользователя
     * https://omni-web.k8s.dev.mos.corp/docs#/goods-lists/goodsListsPostApiV1GoodsDelete
     */
    delete: "/api/v1/goods/delete",

    /**
     * Получение товаров из списка пользователя
     * https://omni-web.k8s.dev.mos.corp/docs#/goods-lists/goodsListsPostApiV2GoodsGet
     */
    get: "/api/v2/goods/get",
  },

  postCheckout: {
    /**
     * GET Возвращает количество активных заказов пользователя.
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV1OrdersCount
     */
    ordersCount: "/v1/orders/count",

    /**
     * GET Возвращает общую сумму выгоды пользователя.
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV1OrdersUserTotalDiscount
     */
    totalDiscount: "/v1/orders/user_total_discount",

    /**
     * GET Возвращает информацию для отслеживания местоположения курьера по заказу
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersByIdCourier
     */
    courier: (id: string) => `/v2/orders/${id}/courier`,

    /**
     * GET Возвращает список товаров доступных к возврату по заказу.
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersByIdReturnReturnableItems
     */
    returnableItems: (id: string) => `/v2/orders/${id}/return/returnable-items`,

    /**
     * GET Возвращает список возвратов по заказу
     * POST Создает возврат по заказу
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersByIdReturns
     */
    returns: (id: string) => `/v2/orders/${id}/returns`,

    /**
     * GET Возвращает список активных заказов клиента
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersActiveList
     */
    ordersActive: "/v2/orders/active/list",

    /**
     * GET Возвращает список архивных заказов клиента (statuses CANCELED, COMPLETED, ISSUED_TO_BUYER, NO_REPURCHASE, UNDELIVERED)
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersArchiveList
     */
    ordersArchive: "/v2/orders/archive/list",

    /**
     * GET Список причин отмен
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersCancelReasons
     */
    cancelReasons: "/v2/orders/cancel-reasons",

    /**
     * GET Отменяет заказ.
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersCancelById
     */
    cancel: (id: string) => `/v2/orders/cancel/${id}`,

    /**
     * GET Получение истории заказов по месяцам
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersHistoryList
     */
    ordersHistoryList: "/v2/orders/history/list",

    /**
     * GET Возвращает информацию по заказу
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutGetV2OrdersInfoById
     */
    info: (id: string) => `/v2/orders/info/${id}`,

    /**
     * POST Repeat order.
     * https://omni-web.k8s.dev.mos.corp/docs#/postcheckout/postcheckoutPostV2OrdersReorderById
     */
    reorder: (id: string) => `/v2/orders/reorder/${id}`,
  },

  userReviews: {
    /**
     * GET Получить анкету для пользователя по ID анкеты
     * https://omni-web.k8s.dev.mos.corp/docs#/user-reviews/userReviewsGetV2PollByPollId
     */
    getPollById: (id: string) => `/v2/poll/${id}`,

    /**
     * POST Сохранить фидбэк (ответы на анкету)
     * https://omni-web.k8s.dev.mos.corp/docs#/user-reviews/userReviewsPostV2ObjectFeedback
     */
    feedback: "/v2/object/feedback",

    /**
     * GET Проверяет, можно ли "оценить" заказы по их id (заказы завершены и нет отзыва от пользователя).
     * Если да - отдает id опроса и meta для передачи в get_poll_by_id_v2 (и get_poll_by_id_v3)
     * https://omni-web.k8s.dev.mos.corp/docs#/user-reviews/userReviewsGetV1OrdersPoll
     *
     */
    ordersPoll: "/v1/orders/poll",
  },
};

export { urls, HttpCodes, ErrorCodes };
